import React from 'react'
import type { Attachment } from 'entities/Attachment/model/Attachment'
import { RinglessContent } from './RinglessContent/RinglessContent'
import { SMSContent } from './SMSContent/SMSContent'

type MessageContentProps = {
  type: 'sms' | 'ringless' | 'rcs'
  attachments: Attachment[]
  message: string
  isDetailsMode?: boolean
}

export const MessageContent = ({
  type,
  attachments,
  message,
  isDetailsMode,
}: MessageContentProps) => {
  if (type === 'sms' || type === 'rcs') {
    return <SMSContent attachments={attachments} message={message} isDetailsMode={isDetailsMode} />
  }
  if (type === 'ringless') {
    return <RinglessContent attachments={attachments} />
  }
  return <></>
}
